import styled from '@emotion/styled';
import Loading from '../Loading';

const StyledLoading = styled(Loading)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 24px;
  height: 600px;
`;

export default StyledLoading;
